export class NumberUtils {
  static isNumberInRange(num: number, min: number, max: number): boolean {
    return num >= min && num <= max;
  }
}
